import { memo } from 'react';

import { CDN_BASE_URL } from 'settings';

import { Image } from './styles';

interface IProps {
  width?: string;
  height?: string;
}

const EmptyStateImage = ({ width, height }: IProps) => {
  return <Image src={`${CDN_BASE_URL}/empty-state.svg`} width={width} height={height} />;
};

export default memo(EmptyStateImage);
